import PropTypes from 'prop-types';
import React from 'react';

import {
  MobileModalContainer,
  MobileModalWrapper,
  MobileModalOverlay,
  MobileModalBody,
  CloseButton
} from './styled';

const MobileModal = ({ children, className, onClose, open }) => (
  <MobileModalWrapper>
    {open && <MobileModalOverlay onClick={onClose} />}
    <MobileModalContainer className={`${className} ${open ? 'active' : ''}`}>
      <CloseButton onClick={onClose}>&#10005;</CloseButton>
      <MobileModalBody>
        {children}
      </MobileModalBody>
    </MobileModalContainer>
  </MobileModalWrapper>
);

MobileModal.defaultProps = {
  children: null,
  className: ''
};

MobileModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  className: PropTypes.string,
  children: PropTypes.node
};

export default MobileModal;